<template>
    <div class="home">
        <Header :app="app" title="Attend" />

        <div class="content home-content">
            <div class="location-table">
                <table class="table">
                    <tbody>
                        <tr v-for="location in app.sortedLocations" :key="location.id">
                            <td>
                                <router-link :to="{ name: 'location', params: { id: location.id } }">
                                    <font-awesome-icon icon="location-arrow" />
                                    {{location.name}}
                                </router-link>
                            </td>
                        </tr>
                        <tr v-if="!app.sortedLocations.length">
                            <td>
                                <a class="align-center">
                                    You have no locations set!
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="actions-table">
                <table class="table">
                    <tbody>
                        <tr>
                            <td>
                                <a v-if="!app.sortedLocations.length || app.isPaid" href="javascript:;" v-on:click="app.addLocation()">
                                    <strong>
                                        <font-awesome-icon icon="location-arrow" />
                                        <span v-if="app.isAddingLocation"> Adding Location...</span>
                                        <span v-else> Add A Location</span>
                                    </strong>
                                </a>
                                <a v-else href="https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=29U2LHYQNAURL" target="_blank">
                                    <strong>
                                        <font-awesome-icon icon="project-diagram" />
                                        Upgrade to Add More Locations!
                                    </strong>
                                </a>
                            </td>
                        </tr>

                        <tr v-if="app.sortedLocations.length">
                            <td>
                                <router-link to="/reports">
                                    <strong>
                                        <font-awesome-icon icon="chart-bar" />
                                        Reports
                                    </strong>
                                </router-link>
                            </td>
                        </tr>

                        <tr>
                            <td>
                                <router-link to="/settings">
                                    <strong>
                                        <font-awesome-icon icon="users" />
                                        Staff
                                    </strong>
                                </router-link>
                            </td>
                        </tr>

                        <tr>
                            <td>
                                <a href="javascript:;" v-on:click="app.logout()">
                                    <font-awesome-icon icon="lock" />
                                    Log Out
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import Header from '@/components/header/component.vue';

export default {
    name: 'home',
    props: ['app'],
    components: {
        Header
    }
};
</script>
